import { ReportTemplateVersion } from 'dashboard/models/report-template-version';
import Action from 'lib/interfaces/Action';

export type ReportTemplateVersionActions =
  | Action<
      ReportTemplateVersionActionType.SetReportTemplateVersion,
      SetReportTemplateVersionPayload
    >
  | Action<ReportTemplateVersionActionType.ClearReportTemplateVersion>;

export enum ReportTemplateVersionActionType {
  SetReportTemplateVersion = 'report-template-version/SET_REPORT_TEMPLATE_VERSION',
  ClearReportTemplateVersion = 'report-template-version/CLEAR_REPORT_TEMPLATE_VERSION',
}

interface SetReportTemplateVersionPayload {
  reportTemplateVersion: ReportTemplateVersion;
}

export function setReportTemplateVersion(
  reportTemplateVersion: ReportTemplateVersion,
): Action<
  ReportTemplateVersionActionType.SetReportTemplateVersion,
  SetReportTemplateVersionPayload
> {
  return {
    payload: {
      reportTemplateVersion,
    },
    type: ReportTemplateVersionActionType.SetReportTemplateVersion,
  };
}

export function clearReportTemplateVersion(): Action<ReportTemplateVersionActionType.ClearReportTemplateVersion> {
  return {
    type: ReportTemplateVersionActionType.ClearReportTemplateVersion,
  };
}
